import { DateTime } from "luxon";
import { fenceValueWithVat, otherValueWithVat } from "@/utils";
import { pdf_contract, CONTRACT_FORM_CODE } from "@/documents/contract/pdf_contract.js";
import { moduleSizeText, moduleHeightText, moduleNameKey, isPost } from "@/utils/fenceModules";

export default {
  create(contract, executantDetails, firmaMontajContract, aditionalExtra) {
    return {
      contract,
      executantDetails,
      firmaMontajContract,
      aditionalExtra,

      // The offer this act replaces: the contract's own for act 1, the one the previous act
      // brought after it. Act 1 keeps reading the contract, as it did when a contract had one act.
      get previousOffer() {
        return this.aditionalExtra.previous || this.contract
      },

      get previousOfferId() {
        const previous = this.aditionalExtra.previous
        return previous ? previous.new_offer_id : this.contract.oferta_id
      },

      get previousOfferDate() {
        const previous = this.aditionalExtra.previous
        return DateTime.fromISO(String(previous ? previous.date_new_offer : this.contract.oferta_data)).toFormat("dd.MM.yyyy")
      },

      // Where the replaced offer comes from, as said after its price in Art.2
      get previousOfferOrigin() {
        const previous = this.aditionalExtra.previous
        if (!previous) return "auf dessen Grundlage der Vertrag erstellt wurde"
        const date = DateTime.fromISO(String(previous.data)).toFormat("dd.MM.yyyy")
        return `das mit dem Nachtrag Nr. ${previous.id_aditional} vom ${date} eingeführt wurde`
      },
      
      get language() {
        return 'de-DE'
      },

      get isMontajSeparat() {
        return this.contract.detalii.montaj_separat
      },

      get valMasuratori() {
        if (Number(this.previousOffer.masuratori_incluse) === 2) {
          return this.previousOffer.val_masuratori ? Number(this.previousOffer.val_masuratori) * 1.21 : 0
        } else {
          return 0
        }
      },

      get newValMasuratori() {
        if (Number(this.aditionalExtra.masuratori_incluse) === 2) {
          return this.aditionalExtra.val_masuratori ? Number(this.aditionalExtra.val_masuratori) * 1.21 : 0
        } else {
          return 0
        }
      },

      get valMontaj() {
        if (Number(this.previousOffer.montaj_inclus) === 2) {
          return this.previousOffer.val_montaj ? Number(this.previousOffer.val_montaj) * 1.21 : 0
        } else {
          return 0
        }
      },

       get newValMontaj() {
        if (Number(this.aditionalExtra.montaj_inclus) === 2) {
          return this.aditionalExtra.val_montaj ? Number(this.aditionalExtra.val_montaj) * 1.21 : 0
        } else {
          return 0
        }
      },

      get valTransport() {
        if (Number(this.previousOffer.transport_inclus) === 2) {
          return this.previousOffer.val_transport ? Number(this.previousOffer.val_transport) * 1.21 : 0
        } else {
          return 0
        }
      },

      get newValTransport() {
        if (Number(this.aditionalExtra.transport_inclus) === 2) {
          return this.aditionalExtra.val_transport ? Number(this.aditionalExtra.val_transport) * 1.21 : 0
        } else {
          return 0
        }
      },

      get sumaContract() {
        let val = (fenceValueWithVat(this.previousOffer) + otherValueWithVat(this.previousOffer) + this.valMasuratori + this.valMontaj + this.valTransport)

        if (+this.contract.firma) {
          val = val / 1.21
        }

        return val
      },

      get newSumaContract() {
        let val = (fenceValueWithVat(this.aditionalExtra) + otherValueWithVat(this.aditionalExtra) + this.newValMasuratori + this.newValMontaj + this.newValTransport)

        if (+this.contract.firma) {
          val = val / 1.21
        }

        return val
      },

      get vatText() {
        return +this.contract.firma ? "ohne MwSt." : "inkl. MwSt."
      },

      // get montajFirma1Text()  {
      //   if (!this.firmaMontajContract) return ''
      //   return `2. S.C. CUPROLLI DESIGN S.R.L., cu sediul in Ghiroda, Str. Caprioarei nr. 11, Jud. Timis, inregistrata in Registrul Comertului sub numarul J2022003676350, cod fiscal 46619944 (neplatitor de TVA), cont bancar: RO74BTRLRONCRT0CH8981101, Banca Transilvania, reprezentata legal prin Rosu Octavian, in calitate de MONTATOR`;
      // },

      // get montajFirma2Text()  {
      //   if (!this.firmaMontajContract) return ''
      //   return `2. S.C. CUPROLLI PARTENER S.R.L., cu sediul in Ghiroda, Str. Caprioarei nr. 11, Jud. Timis, inregistrata in Registrul Comertului sub numarul J2022005419357, cod fiscal 47219300 (neplatitor de TVA), cont bancar: RO14BTRLRONCRT0664679101, Banca Transilvania, reprezentata legal prin Rosu Octavian, in calitate de MONTATOR`;
      // },

      // get montajFirma3Text()  {
      //   if (!this.firmaMontajContract) return ''
      //   return `2. S.C. CUPROLLI PROIECTE S.R.L., cu sediul in Ghiroda, Str. Caprioarei nr. 11, Jud. Timis, inregistrata in Registrul Comertului sub numarul J2022004612351, cod fiscal 46926167 (neplatitor de TVA), cont bancar: RO11BTRLRONCRT0661673901, Banca Transilvania, reprezentata legal prin Rosu Octavian, in calitate de MONTATOR`;
      // },

      get actClient() {
        if (this.contract.detalii.alt_document) {
          return this.contract.detalii.alt_document + ' Nr. ' + this.contract.detalii.alt_document_nr
        }
        return `C.I. serie ${this.contract.detalii.serie_ci} nr. ${this.contract.detalii.numar_ci}`
      },

      get adresaClient() {
        if (this.contract.persoana) {
          return `mit Geschäftssitz in ${this.contract.adresa}`
        } else {
          return `wohnhaft in ${this.contract.detalii.adresa}`
        }
      },

      get exemplareContract() {
        return this.isMontajSeparat ? "3 (drei)" : "2 (zwei)"
      },
      
      get moduleGard() {
        return this.aditionalExtra.gard_obj.map(modul => ({
          type: "listItem",
          content: [{
            type: "paragraph",
            attrs: { textAlign: "left" },
            content: [{
              type: "text",
              // a post has no width, so it is quoted by height alone
              text: isPost(modul.tip)
                ? `${this.denumireModulGard(modul)} - H ${moduleHeightText(modul)} mm - ${modul.buc} Stück`
                : `${this.denumireModulGard(modul)} - mit den Maßen L x H ${moduleSizeText(modul)} mm - ${modul.buc} Stück`
            }]
          }]
        }))
      },

      get moduleCustom() {
        if (!this.aditionalExtra.alte_obj) return []
        return this.aditionalExtra.alte_obj.map(modul => ({
          type: "listItem",
          content: [{
            type: "paragraph",
            attrs: { textAlign: "left" },
            content: [{
              type: "text",
              text: `${this.getTranslatedName(modul.denumire)} - ${modul.cantitate} Stück`
            }]
          }]
        }))
      },

      get executantFirmaText() {
        return `1. CUPROLLI MANUFACTURING SRL, mit Geschäftssitz in CAPRIOAREI Straße, Nr. 11, GHIRODA, Landkreis Timis, Postleitzahl 307200, Rumänien, eingetragen im Handelsregister unter der Nr. J2016000468359, mit der Steuernummer RO 35671874, IBAN: RO89 BTRL EURC RT03 3757 8301, BIC: BTRLRO22, Bankname: Banca Transilvania nachfolgend iSTRUCT bezeichnet, vertreten von Octavian Rosu, als Geschäftsführer.`
      },

      // What a module is called in this contract, keyed by type and variant. Adding a type is a
      // key here and a line in moduleNameKey - never another branch below.
      moduleNames: {
        panel: "Zaunfeld",
        pedestrianGate: "Gartentor",
        pedestrianGateSidePanel: "Gartentor mit Seitenpaneel",
        swingGateSingleLeaf: "Einflügeltor",
        swingGateDoubleLeaf: "Zweiflügeltor",
        swingGateBiFoldSingle: "Einflügeliges Falttor",
        swingGateBiFoldDouble: "Zweiflügeliges Falttor",
        slidingGateSingleLeaf: "Schiebetor",
        slidingGateDoubleLeaf: "Doppelschiebetor",
        slidingGateTelescopic: "Teleskopschiebetor",
        slidingGateArticulated: "Eckschiebetor (90° Winkel)",
        selfSupportingGate: "freitragende Schiebetor",
        posts: "Pfosten",
        post80: "Pfosten 80 × 80 mm",
        post100: "Pfosten 100 × 100 mm",
        post200: "Pfosten 200 × 100 mm",
        framedPanel: "Gerahmte Zaunpaneele"
      },

      denumireModulGard(modul) {
        const key = moduleNameKey(modul.tip, modul.tip_poarta_mare, modul.tip_stalp)
        // a type with no key only ever comes from an offer saved with something since retired
        let name = (key && this.moduleNames[key]) || String(modul.tip || "").replace(/_/g, " ")
        if (modul.pp_included) name += " mit integriertem Fußgängertor"
        return name
      },

      getTranslatedName(name) {
        let newName = name
        if (name == 'Kit automatizare premium poarta culisanta - BFT Deimos Ultra') {
            newName = 'Premium-Schiebetor-Automatisierungskit - BFT Deimos Ultra'
        }
        if (name == 'Kit automatizare premium poarta culisanta - BFT Ares Veloce') {
            newName = 'Premium-Schiebetor-Automatisierungskit - BFT Ares Veloce'
        }
        if (name == 'Kit automatizare premium poarta batanta - BFT Kustos Ultra A40') {
            newName = 'Premium-Zweiflügeltor-Automatisierungskit - BFT Kustos Ultra A40'
        }
        if (name == 'Kit automatizare premium poarta batanta - BFT Virgo') {
            newName = 'Premium-Zweiflügeltor-Automatisierungskit - BFT Virgo'
        }
        return newName
      },

      formatParagraph(textContent, alignment, textType) {
        return {
          type: "paragraph",
          attrs: { textAlign: alignment },
          content: [{
            type: "text",
            text: textContent,
            ...(textType && { marks: [{ type: textType }] })
          }]
        }
      },

      // Main document structure builder
      buildDocumentStructure() {
        return {
          type: "doc",
          content: [
            // Header
            {
              type: "heading",
              attrs: { textAlign: "left", level: 1 },
              content: [{ type: "text", text: `NACHTRAG Nr. ${this.aditionalExtra.id_aditional} / ${DateTime.fromISO(String(this.aditionalExtra.data)).toFormat("dd.MM.yyyy")}` }]
            },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 3 },
              content: [{type: "text", text: "zum Vertrag über die Ausführung von Arbeiten"}]
            },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 3 },
              content: [{type: "text", text: `Nr. ${this.contract.id_contract} / ${DateTime.fromISO(String(this.contract.data)).toFormat("dd.MM.yyyy")}`}]
            },
            {
              type: "paragraph",
              attrs: {
                textAlign: "left",
              },
            },
             {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "VERTRAGSPARTEIEN" }]
            },
            this.formatParagraph(this.executantFirmaText, "left"),
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: `2. ${this.contract.nume.toUpperCase()}, ${this.adresaClient}, ausgewiesen mit ${this.actClient} nachfolgend Kunde bezeichnet.`
              }]
            },
            { type: "blockquote"},
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "heading",
              attrs: {
                textAlign: "left",
                level: 3,
              },
              content: [
                {
                  type: "text",
                  text: `Durch diesen Nachtrag zum Werkvertrag Nr. ${this.contract.id_contract} / ${DateTime.fromISO(String(this.contract.data)).toFormat("dd.MM.yyyy")} werden folgende Änderungen vorgenommen`,
                },
              ],
            },
            {
              type: "paragraph",
              attrs: {
                textAlign: "left",
              },
              content: [
                {
                  type: "text",
                  text:
                    "Art.1. Der Auftraggeber hat denjenigen Teil der Arbeiten, der in seinen Verantwortungsbereich fällt, abgeschlossen, und der Auftragnehmer kann die endgültigen Aufmaße vornehmen.",
                },
              ],
            },
            {
              type: "paragraph",
              attrs: {
                textAlign: "left",
              },
              content: [
                {
                  type: "text",
                  text: `Art.2. Das Angebot Nr. ${this.previousOfferId} din data de ${this.previousOfferDate} sowie der Preis von ${this.sumaContract.toFixed(2)} Euro (${this.vatText}), ${this.previousOfferOrigin}, werden durch das Angebot Nr. ${this.aditionalExtra.new_offer_id} din data ${DateTime.fromISO(String(this.aditionalExtra.date_new_offer)).toFormat("dd.MM.yyyy")} und den Preis von ${this.newSumaContract.toFixed(2)} Euro (${this.vatText}) ersetzt. Dieses neue Angebot wird Bestandteil des Vertrages und basiert auf den unten aufgeführten Elementen und Abmessungen, welche auf Grundlage der endgültigen Aufmessung vom ....................... berechnet wurden.`,
                },
              ],
            },
            {
              type: "bulletList",
              content: this.moduleGard,
            },
            {
              type: "bulletList",
              content: this.moduleCustom,
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "paragraph",
              attrs: {
                textAlign: "left",
              },
              content: [
                {
                  type: "text",
                  text: `Dieses Zusatzdokument wurde heute, am ${DateTime.fromISO(String(this.aditionalExtra.data)).toFormat("dd.MM.yyyy")} in ${this.exemplareContract} gleichlautenden Exemplaren ausgefertigt, von denen jede Partei ein Exemplar erhält.`,
                },
              ],
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            // Signatures
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                marks: [{ type: "bold" }],
                text: "AUFTRAGNEHMER"
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{ type: "text", text: 'CUPROLLI MANUFACTURING SRL (iSTRUCT)' }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{ type: "text", text: this.executantDetails.legal_representative }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "paragraph",
              attrs: { textAlign: "right" },
              content: [{
                type: "text",
                marks: [{ type: "bold" }],
                text: "AUFTRAGGEBER"
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "right" },
              content: [{ type: "text", text: this.contract.nume.toUpperCase() }]
            },
            this.contract.persoana ? {
              type: "paragraph",
              attrs: { textAlign: "right" },
              content: [{ type: "text", text: this.contract.persoana }]
            } : { type: "blockquote" }
          ]
        }
      },

      // PDF Generation
      async generatePdf(documentText) {
        const doc = await pdf_contract.createContractPDF(documentText.content, contract.country, CONTRACT_FORM_CODE)
        return doc
      }
    }
  }
}